import * as React from 'react';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

export default function OverlayLoader({ open, setOpen, text }) {
	return (
		<div>
			<Backdrop
				sx={{ color: '#fff', zIndex: theme => theme.zIndex.drawer + 1 }}
				open={open}
			>
				<CircularProgress color='inherit' />
			</Backdrop>
		</div>
	);
}
